

export const menuItemsData = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About Us",
    url: "/about",
    // submenu: [
    //   {
    //     title: "About us",
    //     url: "about",
    //   },
    //   {
    //     title: "Mission",
    //     url: "mission",
    //   },
    //   {
    //     title: "Inspiration",
    //     url: "inspiration",
    //   },
    //   {
    //     title: "Head of School",
    //     url: "headofschool",
    //   },
    //   // {
    //   //   title: "About us",
    //   //   url: "web-dev",
    //   //   submenu: [
    //   //     {
    //   //       title: "Frontend",
    //   //       url: "frontend",
    //   //     },
    //   //     {
    //   //       title: "Backend",
    //   //       submenu: [
    //   //         {
    //   //           title: "NodeJS",
    //   //           url: "node",
    //   //         },
    //   //         {
    //   //           title: "PHP",
    //   //           url: "php",
    //   //         },
    //   //       ],
    //   //     },
    //   //   ],
    //   // },
    //     // {
    //     //   title: "SEO",
    //     //   url: "seo",
    //     // },
    // ],
  },
  {
    title: "Admission",
    url: "/admission",
  },
  // {
  //   title: "About",
  //   url: "/about",
  // },

    {
    title: "IB Updates",
    url: "/ibupdate",
  },

  {
    title:"Programme",
    submenu: [
      {
        title: "IBPYP",
        url:"pyp",
        submenu:[
          {
            title:'About The Programme',
            url:'pyp',
          },
          {
            title:'PYP POI',
            url:'pyppoi',
          },
          {
            title: 'Parent Oriention PYP',
            url: 'popyp',

          }
        ]
      },
      {
        title: "IGCSE",
        url: "igcse",
        submenu: [
          {
            title:"About The Programme",
            url: "igcse",
           
          },
       
          {
            title:"Book List",
            url: "igcse-booklist",
          }

        ]
      },
      
      {
        title: "IBDP",
        url: "ibdp", 
        submenu: [
          {
            title:"About The Programme",
            url:"ibdp",
          },
      
          {
            title: "IBDP Handbook",
            url: "ibdp-handbook",
          },
          {
            title: "IBDP Orientation",
            url: "parentorientationibdp",
          },
        
          {
            title: "Book List",
            url: "bookList",
          },

        ]
      },
      {
        title:"Policies",
        url: "policy",
      },
     {
      title:"Calendar",
      url:"calendar",
     }
    ]
  },
  {
    title:"Beyond Academics",
    submenu: [
      {
        title:"Achievements",
        url: "achievements",
      },
      // {
      //   title:"Placements",
      //   url: "placements",
      // },
      {
        title:"Student Council",
        url:"studentcouncil",
      },
      {
        title:"Career Counselling",
        url:"careercounselling",
      },
      {
        title:"Newsletters",
        url:"newsletter",
      },
      {
        title:"Sanskar Team",
        url:"ourstaff",
      },
      {
        title:"Circular",
        url:"circular",
      }
    ]
  },
  {
    title:"Alumni",
    url:"alumni",
  },
  
  {
    title:"Gallery",
    submenu: [
      {
        title: "Events",
        url: "events",
      },
      {
        title: "Class Exhibiton",
        url: "classexhibition",
      },
      // {
      //   title: "Celebrations",
      //   url: "celebrations",
      // },
      {
        title: "News",
        url: "news",
      },
      {
        title: "Videos",
        url: "videos",
      },
      {
        title: "CAS Experiences",
        url: "casexperiences",
      },
      {
        title: "School Trips",
        url: "schooltrips",
      },
      {
        title: "Visual Arts",
        url: "visualarts",
      },
    ]
  },
  {
    title:"Fee",
    submenu: [
      {
        title: "Fee Structure",
        url: "feestructure",
      },
      {
        title: "Pay Fee",
        url: "onlinefess",
      }
    ]
  },
  {
    title:"Contact Us",
    url: "contact",

  },

  // {
  //   title: "Academic Programme",
  //   // url: "/about",
  //   submenu: [
 
  //     {
  //       title: "IBPYP",
  //       url: "pyp",
  //       submenu: [
  //         {
  //           title:"About The Program",
         
  //           url: "pyp",
  //         },
  //         {
  //           title: "PYP POI",
  //           url: "pyppoi",
  //         },
  //         {
  //           title:"Parent Oriention PYP",
  //           url: "pyppoi",
  //         },
  //       ]
  //     },
      
      // {
      //   title: "IGCSE",
      //   url: "igcse",
      //   submenu: [
      //     {
      //       title:"About The Program",
      //       url: "igcse",
           
      //     },
      //     // {
      //     //   title:"IGCSC syllabus",
      //     //   url: "igcse-syllabus",
      //     // },
      //     {
      //       title:"Book List",
      //       url: "igcse-booklist",
      //     }

      //   ]
      // },
      // {
      //   title: "IBDP",
      //   url: "ibdp", 
      //   submenu: [
      //     {
      //       title:"About the program",
      //       url:"ibdp",
      //     },
          // {
          //   title: "Hand Book",
          //   url: "ibdp-syllabus",
          // },
          // {
          //   title: "IBDP Handbook",
          //   url: "ibdp-handbook",
          // },
          // {
          //   title: "IBDP Orientation",
          //   url: "parentorientationibdp",
          // },
          // {
          //   title: "IBDP Syllabus",
          //   url: "ibdp-syllabus",
          // },
      //     {
      //       title: "Book List",
      //       url: "bookList",
      //     },

      //   ]
      // },
      // {
      //   title: "Policies",
      //   url: "policy",
      //   // url: "policy-new",
      // },
      // {
      //   title: "IBDP Handbooks",
      //   url: "ibdp-handbook",
      //   // submenu: [
      //   //   {
      //   //     title: "IBDP Handbooks",
      //   //     url: "ibdphandbooks",
      //   //   },
      //   //   {
      //   //     title: "CAS Handbooks",
      //   //     url: "cashandbooks",
      //   //   },
      //   //   {
      //   //     title: "TOK Handbooks",
      //   //     url: "tokhandbooks",
      //   //   },
      //   //   {
      //   //     title: "EE Handbooks",
      //   //     url: "eehandbooks",
      //   //   },
      //   // ]
      // },
      // {
      //   title: "Fee Structure",
      //   url: "feestructure",
      // },
      // {
      //   title: "Our Staff",
      //   url: "ourstaff",
      // },
      // {
      //   title: "Syllabus",
      //   url: "syllabus",
      // },
      // {
      //   title: "Book List",
      //   url: "bookList",
      // },
      // {
      //   title: "Curriculum",
      //   url: "curriculum",
      // },
     
      // {
      //   title: "PYP POI",
      //   url: "pyppoi",
      // },
      // {
      //   title: "Parent Orientation to PYP",
      //   url: "parentorientationforpyp",
      // },
      // {
      //   title: "IBDP Orientation",
      //   url: "parentorientationibdp",
      // },
      // {
      //   title: "Calendar",
      //   url: "calendar.jsx",
      // },
      // {
      //   title: "Holiday Homework",
      //   url: "holidayhomework",
      // },
      // {
      //   title: "Home Assignment",
      //   url: "homeassignments",
      // },
  //     {
  //       title: "Circular",
  //       url: "circular",
  //     },
  //     {
  //       title: "Our Staff",
  //       url: "ourstaff",
  //     }
  //   ]
  // },
  // {
  //   title: "Newsletters",
  //   url: "newsletter",
  // },
  
  // {
  //   title: "IBDP Update",
  //   url: "ibdpupdate",
    
  // },
 
  // {
  //   title: "Photo Gallery",
  //   // url: "/about",
  //   submenu: [
  //     {
  //       title: "Events",
  //       url: "events",
  //     },
  //     {
  //       title: "Class Exhibiton",
  //       url: "classexhibition",
  //     },
  //     // {
  //     //   title: "Celebrations",
  //     //   url: "celebrations",
  //     // },
  //     {
  //       title: "News",
  //       url: "news",
  //     },
  //     {
  //       title: "Videos",
  //       url: "videos",
  //     },
  //     {
  //       title: "CAS Experiences",
  //       url: "casexperiences",
  //     },
  //     {
  //       title: "School Trips",
  //       url: "schooltrips",
  //     },
  //     {
  //       title: "Visual Arts",
  //       url: "visualarts",
  //     },
  //   ]
  // },

  // {
  //   title: "Achievements",
  //   url: "achievements",
    
  // },
  // {
  //   title: "Placements",
  //   url: "placements",
    
  // },
  // {
  //   title: "Career-Counselling",
  //   url: "careercounselling",
    
  // },
  // {
  //   title: "Pay Fess",
  //   url: "onlinefess",
    
  // },
  // {
  //   title: "Admission",
    // url: "/about",
    // url:"/admission", 
    // submenu: [
    //   {
    //     title: "IBPYP",
    //     url: "pypadmission",
    //   },
    //   {
    //     title: "IGCSE",
    //     url: "igceadmission",
    //   },
    //   {
    //     title: "IBDP",
    //     url: "ibdpadmission",
    //   },
    //   {
    //     title: "Online Registration",
    //     url: "onlineregistration",
    //   },
    // ]
  // },
  // {
  //   title: "Contact Us",
  //   url: "contact",
    
  // },
];
